<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <job-information>
        </job-information> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import JobInformation from './todo-job-information'
export default {
    components: {
        JobInformation
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-job-information/base-job-information.vue